import React, {Component} from 'react';
import {ChannelLogo} from "../../channels/ChannelLogo";
import {Button} from "reactstrap";
import {AddStoreModal} from "../../channels/shopify/AddStoreModal";
import {ConnectShopifyClientModal} from "../../channels/shopify/ConnectShopifyClientModal";
import {AddTiendaNubeStoreModal} from "../../channels/tienda_nube/AddTiendaNubeStoreModal";
import {AddKlaviyoAccountModal} from "../../channels/klaviyo/AddKlaviyoAccountModal";
import {AddWooCommerceStoreModal} from "../../channels/woocommerce/AddWooCommerceStoreModal";
import {AddVtexStoreModal} from "../../channels/vtex/AddVtexStoreModal";
import {Spinner} from "../../Spinner";
import {AdAccountDataRow} from "./AdAccountDataRow";
import { withTranslation } from 'react-i18next';
import {toast} from 'react-toastify';
import {SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, KLAVIYO_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL} from "../../channels/channels";
import {UserModulesContext} from "../../../context/UserModulesContext";
import {ShopifyLinkRequestsNotice} from "../../channels/shopify/ShopifyLinkRequestsNotice";


class EcommerceConnectionsComponentClass extends Component {
    // Shopify por link de instalación (tanda 23/10): con el flag, la caja de Shopify muestra los pedidos de link
    // y no ofrece «Mandar link al cliente» (su reemplazo es «Copiar link para tu cliente», en esos pedidos).
    static contextType = UserModulesContext;

    shopifyByLink() {
        return this.props.channel === SHOPIFY_CHANNEL && !!this.context && this.context.shopifyInstallByLink === true;
    }

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo channel={this.props.channel}/>{this.props.channel === KLAVIYO_CHANNEL ? t('ecommerce_connections_component.klaviyo_title') : t('ecommerce_connections_component.title')}</h2>{this.renderLinkStoreButton()}
                </header>
                {/* Se protege solo con el flag: sin él, o sin pedidos, no deja ningún hueco. */}
                {this.props.channel === SHOPIFY_CHANNEL && (
                    <ShopifyLinkRequestsNotice wrapper={(card) => <div className="shl-requests-classic">{card}</div>}/>
                )}
                {this.getTableDataForLinkedStores()}
            </div>
        );
    }

    renderLinkStoreButton() {
        const { t } = this.props;
        // Momento de éxito: al conectar una tienda recordamos que la conexión sola no trae
        // datos hasta vincularla a un cliente. La fila recién refrescada ya ofrece el botón
        // "Vincular a un cliente" (ver AdAccountDataRow), así que el toast apunta a esa acción.
        const afterConnect = (data) => {
            toast.success(t('ecommerce_connections_component.store_connected_link_reminder'));
            if (this.props.onAdAccountConnectionCreated) {
                this.props.onAdAccountConnectionCreated(data);
            }
        };
        return <div className="float-right">
            {this.props.channel === SHOPIFY_CHANNEL && this.shopifyByLink() && (
                <span style={{display: 'inline-flex', gap: '0.5em', alignItems: 'center'}}>
                    <div className="info-icon-container">
                        <Button
                            className="-alt"
                            onClick={(e) => {e.stopPropagation(); this.addStoreModal.toggle()}}
                        >
                            {t('ecommerce_connections_component.new_connection')}
                        </Button>
                        {/* El tooltip de siempre hablaba del OAuth: con el link, dice cómo se conecta ahora. */}
                        <div className="warning-tooltip -below-right -rich">
                            <div className="warning-tooltip-body">
                                <p className="warning-tooltip-text">{t('shopify_link.platform_hint')}</p>
                            </div>
                        </div>
                    </div>
                    <AddStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={afterConnect}/>
                </span>
            )}
            {this.props.channel === SHOPIFY_CHANNEL && !this.shopifyByLink() && (
                <span style={{display: 'inline-flex', gap: '0.5em', alignItems: 'center'}}>
                    <div className="info-icon-container">
                        <Button
                            className="-alt -negative"
                            onClick={(e) => {e.stopPropagation(); this.connectClientModal.toggle()}}
                        >
                            {t('ecommerce_connections_component.send_link_to_client')}
                        </Button>
                        <div className="warning-tooltip -below-right -rich">
                            <div className="warning-tooltip-body">
                                <p className="warning-tooltip-text" dangerouslySetInnerHTML={{__html: t('ecommerce_connections_component.send_link_to_client_tooltip')}}/>
                            </div>
                        </div>
                    </div>
                    <div className="info-icon-container">
                        <Button
                            className="-alt"
                            onClick={(e) => {e.stopPropagation(); this.addStoreModal.toggle()}}
                        >
                            {t('ecommerce_connections_component.new_connection')}
                        </Button>
                        <div className="warning-tooltip -below-right -rich">
                            <div className="warning-tooltip-body">
                                <p className="warning-tooltip-text" dangerouslySetInnerHTML={{__html: t('ecommerce_connections_component.new_connection_tooltip_shopify')}}/>
                            </div>
                        </div>
                    </div>
                    <AddStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={afterConnect}/>
                    <ConnectShopifyClientModal ref={instance => { this.connectClientModal = instance;}}/>
                </span>
            )}
            {this.props.channel !== SHOPIFY_CHANNEL && (
                <Button className="-alt" onClick={(e) => {e.stopPropagation(); this.addStoreModal.toggle()}}>
                    {t('ecommerce_connections_component.new_connection')}
                </Button>
            )}
            {this.props.channel === TIENDA_NUBE_CHANNEL && <AddTiendaNubeStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={afterConnect}/>}
            {this.props.channel === KLAVIYO_CHANNEL && <AddKlaviyoAccountModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={afterConnect}/>}
            {this.props.channel === WOOCOMMERCE_CHANNEL && <AddWooCommerceStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={afterConnect}/>}
            {this.props.channel === VTEX_CHANNEL && <AddVtexStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={afterConnect}/>}
        </div>;
    }

    getTableDataForLinkedStores() {
        const { t } = this.props;
        if (this.props.adAccountConnections !== null) {
            const result = [<div className="table-box">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('ecommerce_connections_component.store')}</th>
                        {this.renderClientColumn()}
                        <th>{t('ecommerce_connections_component.url')}</th>
                        {this.renderAuthorizesColumn()}
                        <th>{t('ecommerce_connections_component.clients')}</th>
                        <th>{t('ecommerce_connections_component.accessible')}</th>
                        <th>{t('ecommerce_connections_component.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.adAccountConnectionsRows()}
                    </tbody>
                </table>
            </div>];

            return result;
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderClientColumn() {
        const { t } = this.props;
        if (this.showClientColumn()) {
            return (<th>{t('ecommerce_connections_component.client')}</th>);
        } else {
            return null;
        }
    }

    renderAuthorizesColumn() {
        const { t } = this.props;
        if (this.props.channel === TIENDA_NUBE_CHANNEL || this.props.channel === KLAVIYO_CHANNEL || this.props.channel === WOOCOMMERCE_CHANNEL || this.props.channel === VTEX_CHANNEL) {
            return null;
        }
        return <th>{t('ecommerce_connections_component.authorizes')}</th>;
    }

    showClientColumn() {
        return false;
    }

    adAccountConnectionsRows() {
        if(!this.props.adAccountsDatas)
            return;

        return this.props.adAccountsDatas.filter((adAccountData) => adAccountData.has_agency_ad_account_credential === true).map((adAccountData) =>
            <AdAccountDataRow key={adAccountData.ad_account_id}
                              adAccountData={adAccountData}
                              onRemove={this.props.doAdAccountRemove}
                              isSaving={this.props.isSaving}
            />
        );
    }
}

export const EcommerceConnectionsComponent = withTranslation()(EcommerceConnectionsComponentClass);
export default EcommerceConnectionsComponent;
